// extracted by mini-css-extract-plugin
module.exports = {"lockBtn":"styles_lockBtn__jUM6p","hideBtn":"styles_hideBtn__tbgW-","infoAnswer":"styles_infoAnswer__1es9R","icon":"styles_icon__3uF6z"};